// w17 Olovgul — autumn-warmth wedding template (terracotta + burnt orange
// + cream + chestnut) rendered byte-for-byte from a standalone HTML file
// inside a full-bleed iframe. The HTML lives at /templates/olovgul.html.
// We forward names/date/venue/address/time as URL params; the inline
// customizer script at the top of the HTML walks text nodes to replace
// the mock placeholders before the countdown / IntersectionObserver wire
// up. A v=1 cache buster is appended because Vite doesn't hash files in
// /public — this lets us bump the template without stale-cache pain.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/olovgul.html";

export function OlovgulStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) params.set("date", t.date);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  // Demo / preview surfaces (gallery thumbnail, "see fullscreen" link,
  // editor preview iframe) leave ctx.slug undefined — we keep the mock
  // wishbook content visible so visitors browsing the catalog see what
  // a populated wishbook reads like.
  if (ctx.slug) params.set("slug", ctx.slug);
  if (t.musicTrackId) params.set("audio", `/music/${t.musicTrackId}.mp3`);
  // Bump when the static HTML changes — Vite doesn't hash files in
  // public/, so without a query string the browser caches the file and
  // skips updates.
  params.set("v", "4");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Olovgul"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#F2E2C9",
      }}
    />
  );
}
